import {twMerge} from '../../../common/twMerge';
import {Text} from '../../atoms/Text/Text';
import {LabelProps} from './LabelProps.interface';
import {LabelType} from './LabelType.enum';

export function Label({type, text, className, ...props}: LabelProps) {
  return (
    <div
      className={twMerge(
        'font-x-small1 inline-flex h-16pxr items-center justify-center rounded-2pxr px-3pxr',
        LABEL_TYPE_STYLE_MAP[type],
        className
      )}
      {...props}
    >
      <Text>{text}</Text>
    </div>
  );
}

const LABEL_TYPE_STYLE_MAP: {
  [key in LabelType]: string;
} = {
  [LabelType.Static01]: 'text-static-mono-black bg-static-point-yellow',
  [LabelType.Static02]: 'text-static-mono-90 bg-static-mono-white',
  [LabelType.Static04]: 'text-static-mono-10 bg-static-point-red',
  [LabelType.Static05]: 'text-static-mono-10 bg-static-point-green',
  [LabelType.Static06]:
    'font-x-small1-bold text-static-mono-white bg-static-point-red rounded-5pxr',
  [LabelType.DarkLight01]: 'text-theme-solid-100 bg-theme-solid-0',
  [LabelType.DarkLight02]: 'text-theme-solid-100 bg-theme-solid-20',
  [LabelType.DarkLight03]: 'text-theme-solid-100 bg-theme-solid-20',
};
